// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"1e4727b9","128":"cfa5038d","811":"55a0e40c"}[chunkId] + ".css";
};